import { TStaff } from "~/types/staff";

/**
 * Formats staff name as "FirstName L." or falls back to username/Unknown
 * Never returns staffRef which is confusing to users
 */
export const formatStaffName = (staff: TStaff | null | undefined): string => {
  if (!staff) return "Unknown";

  const firstName = staff.user?.firstName || "";
  const lastName = staff.user?.lastName || "";

  if (firstName && lastName) {
    return `${firstName} ${lastName.charAt(0)}.`;
  }

  if (firstName) {
    return firstName;
  }

  if (staff.user?.username) {
    return staff.user.username;
  }

  // Last resort: use Unknown instead of staffRef
  return "Unknown";
};

/**
 * Formats staff name with full last name for detailed views
 */
export const formatStaffFullName = (staff: TStaff | null | undefined): string => {
  if (!staff) return "Unknown";

  const firstName = staff.user?.firstName || "";
  const lastName = staff.user?.lastName || "";

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  if (firstName) {
    return firstName;
  }

  if (staff.user?.username) {
    return staff.user.username;
  }

  return "Unknown";
};
